var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlutenFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58.2 58.2",
    style: {
      enableBackground: "new 0 0 58.2 58.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3C1412;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gluten_x5F_FREE",
    className: "st0",
    d: "M11.2,51.9l-0.8-0.6C3.9,45.7,0.1,37.6,0.1,29.1C0.1,13,13.2,0,29.2,0 c14.1,0,26.1,10,28.6,23.9l0.2,1L11.2,51.9z M15.8,39.5c0,0,4.7-0.4,8.1,1.8l2-1.2c-2.1-0.1-5.2-0.7-7.3-2.8 c-3.4-3.4-2.8-9.4-2.8-9.4s6-0.5,9.4,2.8c2.4,2.4,2.8,6.2,2.9,8.2l1.4-0.8c0.1-2.1,0.7-5.2,2.8-7.3c3.4-3.4,9.4-2.8,9.4-2.8 s0.1,1.4-0.1,3.2l13.3-7.7c-2.6-12-13.3-20.6-25.6-20.6C14.8,2.8,3,14.6,3,29.1c0,7.4,3.1,14.4,8.5,19.3l5-2.9 C15.5,42.5,15.8,39.5,15.8,39.5z M41.6,16.3c0,0,0.5,6-2.8,9.4c-3.4,3.4-9.4,2.8-9.4,2.8s-0.5-6,2.8-9.4 C35.6,15.8,41.6,16.3,41.6,16.3z M28.7,3.6c0,0,4.6,3.9,4.6,8.6c0,4.8-4.6,8.6-4.6,8.6s-4.6-3.9-4.6-8.6C24.1,7.4,28.7,3.6,28.7,3.6 z M15.8,16.3c0,0,6-0.5,9.4,2.8c3.4,3.4,2.8,9.4,2.8,9.4s-6,0.5-9.4-2.8C15.2,22.4,15.8,16.3,15.8,16.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlutenFree);
export default __webpack_public_path__ + "static/media/gluten-free.24fc2d3016da02f5ef9b272bb4d2f7ef.svg";
export { ForwardRef as ReactComponent };